import React from "react"
import { Outlet } from "react-router-dom"
import Meta from "../../../Components/Meta"
import NavigationBar from "../NavigationBar"
import NewFooter from "../NewFooter"

const Layout = () => {
    return (
        <>
            <Meta />
            <NavigationBar />
            <div className="main-screen">
                <Outlet />
            </div>
            <NewFooter />
        </>
    )
}

export default Layout